// Importações do Firebase
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { firestoreId } from '../../../globalVars/data';

// Configuração do Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyBJ1MNdqlCOmPXK3taPtmuEJbsrmtiUDxU',
  authDomain: 'goodbike-cd338.firebaseapp.com',
  projectId: 'goodbike-cd338',
  storageBucket: 'goodbike-cd338.appspot.com',
  messagingSenderId: '177294326394',
  appId: '1:177294326394:web:00671a5c16846c33e499c3',
};

// Inicializar Firebase como instância "secondary"
const appName = 'secondary';
export const fbInit = getApps().some(app => app.name === appName)
  ? getApp(appName) // Obtém a instância se já existir
  : initializeApp(firebaseConfig, appName); // Inicializa se não existir

// Agora, vincule a instância do Firestore corretamente
export const firestoreOutFlax = getFirestore(fbInit, firestoreId);
